import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=1db3f9bc&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Settings.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Settings.vue
// module id = 2434
// module chunks = 1